import { Dispatch, FC, SetStateAction } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import { useExternalModal } from 'ui/partials/Modal/useModal';
import { Lead } from 'utils/types';

import SimpleLeadForm from '../forms/SimpleLeadForm';
import {
  LEAD_FORM,
  SIMPLE_LEAD_SCHEMA,
  SIMPLE_LEAD_FORM,
} from '../forms/schema';
import useCreateLead from '../hooks/useCreateLead';

interface PROPS {
  setForm?: Dispatch<SetStateAction<any>>;
  afterCreate?: (deal: Lead) => void;
  onCancel?: () => void;
  initValues?: Partial<typeof FORM_INIT>;
}

const FORM_INIT = {
  firstName: '',
  emailAddress: '',
  mobileNumber: '',
};

const CreateSimpleLeadModal: FC<PROPS> = ({
  setForm,
  afterCreate,
  onCancel,
  initValues,
}) => {
  const { mutate: addLead } = useCreateLead({ disableHide: true });
  const { hideModal } = useExternalModal();

  const onSubmit = (
    values: SIMPLE_LEAD_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_LEAD_FORM>,
  ) => {
    addLead(values as LEAD_FORM, {
      onSuccess: () => {
        hideModal();
      },
      onSettled: ({ data }: any) => {
        setForm?.((prevState: any) => ({
          ...prevState,
          leadId: [...(prevState?.leadId ?? []), { ...data }],
        }));

        afterCreate?.(data);

        setSubmitting(false);
      },
      onError: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik<SIMPLE_LEAD_FORM>
      initialValues={{ ...FORM_INIT, ...initValues }}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_LEAD_SCHEMA}
    >
      {() => <SimpleLeadForm onCancel={onCancel ?? hideModal} />}
    </Formik>
  );
};

export default CreateSimpleLeadModal;
